export const throttle = (func, limit) => {
  let inThrottle
  return function (...args) {
    if (!inThrottle) {
      func.apply(this, args)
      inThrottle = true
      setTimeout(() => inThrottle = false, limit)
    }
  }
}

export const getOptimalClusterRadius = (zoom) => {
  if (zoom <= 10) return 80
  if (zoom <= 15) return 60
  return 40
}

export const getOptimalMinPoints = (deviceCount) => {
  if (deviceCount > 50000) return 5
  if (deviceCount > 10000) return 3
  return 2
}

export const batchProcess = async (items, processItem, batchSize = 1000) => {
  const results = []

  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize)
    const batchResults = batch.map(processItem)
    results.push(...batchResults)

    await new Promise(resolve => setTimeout(resolve, 0))
  }

  return results
}